//currently rendering dummy locations moving around
import { Link } from "react-router-dom";
import { dummyPlaces } from "../../dummyData";
import MapComponentJsx from "../specials/MapComponent";
import { useEffect, useState } from "react";
import { useTranslation } from "../../languages";
import { useSelector } from "react-redux";
const getRGBValue = () => Math.floor(Math.random() * 255);
const getRandomStyle = () => {
  let randomLeft = `${Math.floor(Math.random() * 90)}%`;
  let randomTop = `${Math.floor(Math.random() * 50)}%`;
  let randomBg = `rgba(${getRGBValue()},${getRGBValue()},${getRGBValue()})`;
  return { left: randomLeft, top: randomTop, "--background": randomBg };
};
const UserHomeMap = ({ placesData,mapCenter,setMapCenter,userLocation,normalEvents=[] }) => {
  const user = useSelector((s) => s?.user ?? {});

  const [places, setPlaces] = useState([]);

  const { t } = useTranslation();
  const getDetailsLink = (details) => {

    switch (details?.types?.[0]) {
      case "resturant":
        return `/places/resturant/${details?._id}`;
      case "special-event":
        return `/places/special-event/${details?._id}`;
      case "kids":
        return `/places/kids/${details?._id}`;
      case "event":
        return `/places/event/${details?._id}`;
      case "date":
        return `/places/date/${details?._id}`;
      case "culture":
        return `/places/culture/${details?._id}`;
      case "sports":
        return `/places/sports/${details?._id}`;
      case "adventure":
        return `/places/adventure/${details?._id}`;
      default:
        return `/places/resturant/${details?._id}`;
    }
  };
  const showPlaces = () => {
    console.log("Places Data.....",placesData);
    if (!placesData) return;
    let array = placesData.map((item) => {
      return {
        lat: item?.geo?.coordinates?.[1],
        lng: item?.geo?.coordinates?.[0],
        link: getDetailsLink(item),
        ...item,
      };
    });
  
    setMapCenter?.({
      lat: userLocation?.latitude,
      lng: userLocation?.longitude,
    });
    setPlaces(array);
  };
  useEffect(() => {
    
    showPlaces();
   
  }, [placesData,userLocation]);



console.log("normal-events",normalEvents)

  return (
    <div className="user-home-map position-relative  mt-2rem">
      <MapComponentJsx
        center={mapCenter}
        bodies={places}
        allEvents={normalEvents}
        userLocation={userLocation}
        className={"standard-map"}
        containerStyle={{ height: "76vh", width: "100%" }}
      />
      {user?.roles[0] !== "contributor" && (
        <div className="content position-absolute left-0 full-width d-flex align-items-center justify-content-center ">
          <h4 className="text-white f-4 m-0">{t("commercialAds")}</h4>
        </div>
      )}
    </div>
  );
};
export default UserHomeMap;
